(() => {
  if (window.gdxInlineReviews) return;
  window.gdxInlineReviews = true;
  const videos = new Set();
  const mounted = new WeakSet();
  let activeVideo = null;
  const pause = video => {
    if (activeVideo === video) activeVideo = null;
    video.pause();
  };
  const pauseOthers = active => videos.forEach(video => { if (video !== active) pause(video); });
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    for (const entry of entries) if (entry.intersectionRatio < .2) {
      const video = entry.target.querySelector('video');
      if (video) pause(video);
    }
  }, {threshold: [0, .2]}) : null;

  function mount(root) {
    root.querySelectorAll('.fx-reviews .gdx-review-play').forEach(button => {
    if (mounted.has(button)) return;
    const card = button.closest('[data-video-url]'), holder = button.closest('.vid');
    if (!card || !holder) return;
    const video = holder.querySelector('video');
    if (!video) return;
    mounted.add(button);
    videos.add(video);
    observer?.observe(holder);
    let touch = null, suppressClickUntil = 0;

    const restorePoster = () => {
      pause(video);
      button.hidden = false;
      video.hidden = true;
    };
    const onPlayFailure = error => {
      if (activeVideo !== video || document.hidden || !video.isConnected) return;
      if (error?.name === 'NotAllowedError' && !video.muted) {
        video.muted = true;
        try { video.play()?.catch(restorePoster); } catch { restorePoster(); }
      } else restorePoster();
    };
    const play = () => {
      pauseOthers(video);
      activeVideo = video;
      video.controls = true;
      video.muted = false;
      video.poster = holder.querySelector('img')?.currentSrc || '';
      video.hidden = false;
      button.hidden = true;
      if (!video.getAttribute('src')) video.src = card.dataset.videoUrl;
      try { video.play()?.catch(onPlayFailure); } catch (error) { onPlayFailure(error); }
    };

    holder.addEventListener('touchstart', () => { suppressClickUntil = 0; }, {passive: true});
    holder.addEventListener('click', event => {
      if (event.detail !== 0 && Date.now() < suppressClickUntil) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
    button.addEventListener('touchstart', event => {
      const point = event.touches.length === 1 ? event.touches[0] : null;
      touch = point ? {id: point.identifier, x: point.clientX, y: point.clientY, moved: false} : null;
    }, {passive: true});
    button.addEventListener('touchmove', event => {
      if (!touch) return;
      const point = Array.from(event.touches).find(point => point.identifier === touch.id);
      if (!point || event.touches.length !== 1 || Math.hypot(point.clientX - touch.x, point.clientY - touch.y) > 10) touch.moved = true;
    }, {passive: true});
    button.addEventListener('touchcancel', () => { touch = null; });
    button.addEventListener('touchend', event => {
      const gesture = touch;
      touch = null;
      if (!gesture) return;
      const point = Array.from(event.changedTouches).find(point => point.identifier === gesture.id);
      suppressClickUntil = Date.now() + 800;
      if (gesture.moved || !point || event.touches.length || Math.hypot(point.clientX - gesture.x, point.clientY - gesture.y) > 10) return;
      event.preventDefault();
      event.stopPropagation();
      play();
    }, {passive: false});
    button.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      play();
    });
    video.addEventListener('play', () => { pauseOthers(video); activeVideo = video; });
    video.addEventListener('error', restorePoster);
    });
  }
  mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('visibilitychange', () => { if (document.hidden) pauseOthers(); });
  document.addEventListener('shopify:section:unload', event => {
    for (const video of videos) if (event.target.contains(video)) {
      pause(video);
      observer?.unobserve(video.closest('.vid'));
      videos.delete(video);
    }
  });
})();
